import { render, staticRenderFns } from "./SuspendButton.vue?vue&type=template&id=c9e869f8&scoped=true&"
import script from "./SuspendButton.vue?vue&type=script&lang=js&"
export * from "./SuspendButton.vue?vue&type=script&lang=js&"
import style0 from "./SuspendButton.vue?vue&type=style&index=0&id=c9e869f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e869f8",
  null
  
)

export default component.exports